export const STATUS_CODE_SHOPPING_CART = {
  ADDED: 'ADDED',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
};
